import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import '@/assets/css/main.css'

import { TokenService } from "@/service/Storage.Service.js"

import Convert from "./plugins/Convert"
import VeeValidate from "./plugins/VeeValidate"
import VueQuillEditor from "@/plugins/VueQuillEditor"
import vuetify from './plugins/vuetify';
import VueApexCharts from './plugins/VueApexCharts';
import VueDateTimePicker from '@/plugins/VueDateTimePicker';
import VCurrencyField from '@/plugins/VCurrencyField';

if (TokenService.getToken()) {
  store.commit("setToken", TokenService.getToken())
  store.commit("setUser", JSON.parse(TokenService.getUser()))
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  Convert,
  VeeValidate,
  VueQuillEditor,
  VueDateTimePicker,
  VCurrencyField,
  vuetify,
  VueApexCharts,
  
  render: h => h(App)
}).$mount('#app')
